import { pr, ui } from "aaa";
import { AppointmentRoutes } from "components/appointment/AppointmentRoutes";
import { GdsFakeActionButton } from "components/common/GdsFakeActionButton";
import { ListItem } from "components/common/LandingPage";
import * as React from "react";
import { pushRoute } from "stores/RouterFunctions";
import { InfoContainer } from "./HouseholdInsuranceInfoContainer";
import { SectionContainer } from "./HouseholdInsuranceSectionContainer";
import trackingStore from "stores/TrackingStore";


export const HouseholdInsuranceDenialInfo = () => {
    const handleClickMakeAppointment = async () => {
        await trackingStore.trackEvent({ eventName: "bookAppointment" });
        pushRoute(AppointmentRoutes.ROOT, true);
    };

    return (
        <>
            <SectionContainer>
                <pr.P_16_CONTENT>
                    {ui.__("householdInsurance.landingPage.denialInfo.description")}
                </pr.P_16_CONTENT>
                <InfoContainer>
                    <ListItem>
                        <pr.P_16_CONTENT>
                            {ui.__("householdInsurance.landingPage.denialInfo.listItem1")}
                        </pr.P_16_CONTENT>
                    </ListItem>
                    <ListItem>
                        <pr.P_16_CONTENT>
                            {ui.__("householdInsurance.landingPage.denialInfo.listItem2")}
                        </pr.P_16_CONTENT>
                    </ListItem>
                    <ListItem>
                        <pr.P_16_CONTENT>
                            {ui.__("householdInsurance.landingPage.denialInfo.listItem3")}
                        </pr.P_16_CONTENT>
                    </ListItem>
                </InfoContainer>
                <pr.P_16_CONTENT>
                    {ui.__("householdInsurance.landingPage.denialInfo.contactInfo")}
                </pr.P_16_CONTENT>
                <GdsFakeActionButton
                    color="primary"
                    style={{
                        alignSelf: "center",
                        marginTop: 16,
                        width: "fit-content",
                    }}
                    onClick={handleClickMakeAppointment}
                >
                    {ui.__("householdInsurance.landingPage.denialInfo.contactInfo.button")}
                </GdsFakeActionButton>
            </SectionContainer>
        </>
    )
}


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceDenialInfo.tsx